<template>
    <fieldset
        :id="controlId"
        class="lni-c-checkbox-list"
        :class="{'--required': required}"
    >
        <legend
            class="lni-c-input-list__legend"
            v-if="labelText"
        >
            {{ labelText }}
        </legend>
        <slot />
        <div class="lni-u-flex lni-u-flex-column lni-u-items-start">
            <div
                class='lni-c-checkbox'
                v-for="option in options"
                v-bind:key="option.value" >
                <input
                    :id="controlId + '_' + option.value"
                    class="lni-c-checkbox__input"
                    type="checkbox"

                    :value="option.value"
                    v-on:change="onChange($event, option.value)"
                 />
                 <label
                    :for="controlId + '_' + option.value"
                    class="lni-c-checkbox__label">
                    <span>{{option.text}}</span>
                 </label>
            </div>
        </div>
    </fieldset>
</template>

<script>
import framework from '../../framework';

/**
 *  The x-checkbox-list component.
 *  @module components/x-checkbox-list
 */


/**
 * The x-checkbox-list is a basic set of checkboxes.
 */

export default {
    name: 'x-checkbox-list',
    mixins: [
        framework.mixins.abstractInput,
    ],
    props: {
        dataOptions: Array,
        dataLabelText: String,
    },
    data() {
        return {
            componentValue: [],
        };
    },
    mounted() {
        this.initialize();
    },
    computed: {
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        labelText() {
            return this.getAttribute('labelText', '');
        },

        options() {
            return this.getOptions();
        },
        value: {
            get() {
                return this.componentValue;
            },

            set(newValue) {
                this.$set(this, 'componentValue', newValue);

                if (this.isNested) {
                    // broadcast event that data has changed
                    // This event is caught by a parent that wants to aggregate its
                    // changed value into a complex component
                    this.$emit('dataChanged', this.componentValue);
                    return;
                }

                // if this component is nested, we pass the value up to its parent(see above).
                // if not nested, we put it onto the global manifest.
                if (this.nodeManifest) {
                    this.setValueToManifest(this.componentValue);
                }
            },
        },
    },
    methods: {
        /**
         * Get the values(if it exists yet) from manifest
         * @returns {void}
         */
        setComponentValueFromManifest() {
            if (this.nodeManifest.values && this.nodeManifest.values.length > 0) {
                this.componentValue = this.nodeManifest.values;
            }
        },
        /**
         * Get the values(if it exists yet) from property
         * @returns {void}
         */
        setComponentValueFromProperty() {
            this.componentValue = this.dataValues;
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            this.componentValue.forEach((v) => {
                let el = this.$el.querySelector(`input#${this.controlId}_${v.value}`);
                el.checked = true;
            });
        },

        /**
         * Formats the value of the multiple checkboxes upon a change in one of them.
         * @param {*} event the input event
         * @param {*} value the value of the checkbox.
         * @returns {void}
         */
        onChange(event, value) {
            if (event.target.value) {
                let newComponentValue = this.componentValue.slice(0);
                let checked = event.target.checked;
                if (checked && !newComponentValue.find((v) => v.value === value)) {
                    newComponentValue.push({
                        value,
                    });
                } else if (!checked && newComponentValue.find((v) => v.value === value)) {
                    newComponentValue = newComponentValue.filter((v) => v.value !== value);
                }
                this.value = newComponentValue;
            }

            this.handleErrorState();
        },

        /**
         * Gets the error information off of the input element(s)
         * @returns {void}
         */
        getErrorStateOffInputs() {
            let message = this.required && this.componentValue.length === 0
                ? 'At least one selection is required.'
                : '';
            return this.createValidationPayload(message);
        },
    },
};
</script>

<style lang="scss">
    @import
        "../../styles/settings",
        "../x-checkbox/checkbox",
        "checkbox-list";
</style>



// WEBPACK FOOTER //
// source/components/x-checkbox-list/x-checkbox-list.vue